const STORAGE_KEY = 'toptax_tracking_params'

const PARAM_NAMES = [
  'gclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const

export interface TrackingParams {
  gclid?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  landing_url?: string
}

export const captureTrackingParams = () => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const searchParams = new URLSearchParams(window.location.search)
    const params: TrackingParams = {}

    for (const name of PARAM_NAMES) {
      const value = searchParams.get(name)

      if (value) {
        params[name] = value
      }
    }

    if (Object.keys(params).length === 0) {
      return
    }

    params.landing_url = window.location.href
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params))
  } catch {
    // sessionStorage unavailable (private mode etc.) — tracking is best-effort
  }
}

export const getTrackingParams = (): TrackingParams => {
  if (typeof window === 'undefined') {
    return {}
  }

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    return stored ? (JSON.parse(stored) as TrackingParams) : {}
  } catch {
    return {}
  }
}
